const React = require('react');
const TextFieldP = require('./P');


module.exports = (props) => {
  return (
    <TextFieldP
      {...props}
      helperText={props.helperText || 'Obligatory field'}
    />
  );
};
